module.exports = __webpack_public_path__ + "img/semImagem.b675d873.jpg";